import axiosClient from './axiosClient';

const platformFeaturesApi = {
  list() {
    return axiosClient.get('/platform-features');
  },

  update(featureId, mode) {
    return axiosClient.patch(
      `/platform-features/${featureId}`,
      { mode },
    );
  },

  users(featureId, params = {}) {
    return axiosClient.get(
      `/platform-features/${featureId}/users`,
      { params },
    );
  },

  updateUser(featureId, userId, state) {
    return axiosClient.patch(
      `/platform-features/${featureId}/users/${userId}`,
      { state },
    );
  },
};

export default platformFeaturesApi;